export default function EventPage() {
  return (
    <div className="min-h-screen bg-white flex border-t-2 border-black border-b-2 w-full flex-col md:flex-row font-saol">
      {/* Left Image with Top Labels */}
      <div className="w-full md:w-1/2 relative">
        {/* Overlay Labels */}
        <div className="absolute top-0 left-0 w-full text-center z-10">
          <div className="bg-white/60 backdrop-blur-sm py-1 text-black text-sm md:text-base tracking-wide">
            {["SPECIAL EVENTS", "SPECIAL EVENTS", "SPECIAL EVENTS", "SPECIAL EVENTS"].join(" • ")}
          </div>
          <div className="bg-white/60 backdrop-blur-sm py-1 text-black text-sm md:text-base tracking-wide">
            {["CELEBRATIONS", "CELEBRATIONS", "CELEBRATIONS", "CELEBRATIONS"].join(" • ")}
          </div>
          <div className="bg-white/60 backdrop-blur-sm py-1 text-black text-sm md:text-base tracking-wide">
            {["WEDDINGS", "WEDDINGS", "WEDDINGS", "WEDDINGS"].join(" • ")}
          </div>
        </div>

        {/* Image */}
        <img
          src="/3.webp"
          alt="Private Event"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Text */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-10">
        <h1 className="text-black text-4xl md:text-7xl leading-tight whitespace-pre-line">
          {`Let Emotions\nRun High with\na Private Event`}
        </h1>
      </div>
    </div>
  );
}
